import { useLocalization } from "@fluent/react";
import { Button } from "@narmi/design_system";
import { NavigationType, useBlocker } from "react-router";
import { Card } from "@lending/components/Card/Card";
import { ErrorScreen } from "@lending/components/ErrorScreen/ErrorScreen";
import { PageLayout } from "@lending/components/PageLayout/PageLayout";
import styles from "./DocumentsRequested.module.css";
import { useMembershipShareDocumentWidget, useMembershipShareDocumentsRequested } from "./hooks";

function MembershipShareDocumentsRequested() {
  const { l10n } = useLocalization();
  const { accountApplication, primaryApplicant, isLoading, hasError, accountApplicationUuid } =
    useMembershipShareDocumentsRequested();
  const { isWidgetOpen, isSubmitting, openDocumentWidget } = useMembershipShareDocumentWidget({
    accountApplication,
    primaryApplicant,
    accountApplicationUuid,
    l10n,
  });

  useBlocker((navigation) => {
    return isWidgetOpen && navigation.historyAction === NavigationType.Pop;
  });

  if (isLoading) {
    return <PageLayout isLoading>{null}</PageLayout>;
  }

  if (hasError || !accountApplication) {
    return <ErrorScreen />;
  }

  return (
    <PageLayout className={styles.pageLayout}>
      <div className={styles.container}>
        <div className={styles.content}>
          <div className={styles.header}>
            <h1 className={`fontFamily--heading ${styles.heading}`}>
              {l10n.getString("membership-share-documents-requested-title", null, "Almost there!")}
            </h1>
          </div>

          {!isWidgetOpen && (
            <Card emphasize className={styles.card}>
              <div className={styles.cardContent}>
                <div className={styles.iconContainer} aria-hidden="true">
                  <div className="narmi-icon-file-text1" />
                </div>
                <div className={styles.message}>
                  {l10n.getString(
                    "membership-share-documents-requested-subtitle",
                    null,
                    "We need some additional information to process your application."
                  )}
                </div>
                <div className={styles.buttonContainer}>
                  <Button
                    label={l10n.getString("label-upload-documents", null, "Upload documents")}
                    endIcon="arrow-right"
                    size="s"
                    onClick={openDocumentWidget}
                    isLoading={isSubmitting}
                  />
                </div>
              </div>
            </Card>
          )}

          <div
            id="membership-share-documents-requested-container"
            className={styles.widgetContainer}
          />
        </div>
      </div>
    </PageLayout>
  );
}

export { MembershipShareDocumentsRequested };
